/**
 * KpiCard — key performance indicator card used in Übersicht tab.
 * Ported from v0 kunden-view.tsx KpiCard.
 * Uses OUR Card + tokens.
 */
import type { LucideIcon } from 'lucide-react';
import { Card, CardHeader, CardDescription, CardTitle, CardContent } from '../../../components/ui/Card';

interface KpiCardProps {
  icon: LucideIcon;
  label: string;
  value: string;
  hint?: string;
}

export function KpiCard({ icon: Icon, label, value, hint }: KpiCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardDescription className="flex items-center gap-1.5">
          <Icon className="size-4" />
          {label}
        </CardDescription>
        <CardTitle className="text-2xl tabular-nums">{value}</CardTitle>
      </CardHeader>
      {hint ? <CardContent className="text-xs text-muted-foreground">{hint}</CardContent> : null}
    </Card>
  );
}
